export const FETCH_USERINFO_STARTED = 'FETCH/USERINFO/STARTED';
export const FETCH_USERINFO_SUCCESS = 'FETCH/USERINFO/SUCCESS';
export const FETCH_USERINFO_FAILURE = 'FETCH/USERINFO/FAILURE ';
export const SET_SHOW_MODULE = 'SET/SHOW/MODULE';
export const SET_HOME_STYLE = 'SET/HOME/STYLE';
